<script setup lang="ts">
import { useAppConfig } from '#app/config';

defineProps<{
	disabled?: boolean;
}>();

const emit = defineEmits<{
	deselect: [];
}>();

const appConfig = useAppConfig();

function handleDeselect() {
	emit('deselect');
}
</script>

<template>
	<DButton
		color="neutral"
		variant="ghost"
		data-testid="remove"
		:icon="appConfig.ui.icons.remove"
		:disabled
		:aria-label="$t('common.remove')"
		:ui="{ base: 'rounded-sm' }"
		@click.stop="handleDeselect"
	/>
</template>
